/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITicketUser
 */
export interface APITicketUser {
    /**
     * 
     * @type {string}
     * @memberof APITicketUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketUser
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketUser
     */
    lastName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APITicketUser
     */
    isGuestUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APITicketUser
     */
    isOrgAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APITicketUser
     */
    isStaff?: boolean;
}

/**
 * Check if a given object implements the APITicketUser interface.
 */
export function instanceOfAPITicketUser(value: object): value is APITicketUser {
    return true;
}

export function APITicketUserFromJSON(json: any): APITicketUser {
    return APITicketUserFromJSONTyped(json, false);
}

export function APITicketUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITicketUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'isGuestUser': json['is_guest_user'] == null ? undefined : json['is_guest_user'],
        'isOrgAdmin': json['is_org_admin'] == null ? undefined : json['is_org_admin'],
        'isStaff': json['is_staff'] == null ? undefined : json['is_staff'],
    };
}

export function APITicketUserToJSON(value?: APITicketUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'full_name': value['fullName'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'is_guest_user': value['isGuestUser'],
        'is_org_admin': value['isOrgAdmin'],
        'is_staff': value['isStaff'],
    };
}

